import { render } from "./BatchMap.vue?vue&type=template&id=02defcb3"
import script from "./BatchMap.vue?vue&type=script&lang=js"
export * from "./BatchMap.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\iflam\\OneDrive\\নথিসমূহ\\tms-next\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__